if (!customElements.get("slider-vertical")) {
  class SliderVertical extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.upButton = this.querySelector('button[name="up"]');
      this.downButton = this.querySelector('button[name="down"]');
      this.panel = this.querySelector(".slider-vertical--panel");

      if (!this.upButton || !this.downButton || !this.panel) return;

      this.initialized = true;
      this.onScroll = this.updateButtons.bind(this);
      this.onResize = this.updateButtons.bind(this);
      this.onUp = (event) => {
        event.preventDefault();
        this.move(-1);
      };
      this.onDown = (event) => {
        event.preventDefault();
        this.move(1);
      };

      this.upButton.addEventListener("click", this.onUp);
      this.downButton.addEventListener("click", this.onDown);
      this.panel.addEventListener("scroll", this.onScroll);
      window.addEventListener("resize", this.onResize);

      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.panel);

        for (const child of this.panel.children) {
          this.resizeObserver.observe(child);
        }
      }

      this.updateButtons();
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.upButton.removeEventListener("click", this.onUp);
      this.downButton.removeEventListener("click", this.onDown);
      this.panel.removeEventListener("scroll", this.onScroll);
      window.removeEventListener("resize", this.onResize);
      this.resizeObserver?.disconnect();
      this.initialized = false;
    }

    getThumbsMode() {
      return this.dataset.thumbsMode || "slider_left";
    }

    isVertical() {
      return this.getThumbsMode() === "slider_left";
    }

    getPanelGap() {
      const styles = window.getComputedStyle(this.panel);
      const gap = this.isVertical()
        ? styles.rowGap
        : styles.columnGap;

      return Number.parseFloat(gap) || 0;
    }

    move(direction) {
      const firstThumbnail = Array.from(this.panel.children).find(
        (child) => child.getClientRects().length > 0
      );

      if (!firstThumbnail) return;

      const vertical = this.isVertical();
      const size = vertical
        ? firstThumbnail.offsetHeight
        : firstThumbnail.offsetWidth;

      const distance = direction * (size + this.getPanelGap());
      const reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      this.panel.scrollBy({
        top: vertical ? distance : 0,
        left: vertical ? 0 : distance,
        behavior: reducedMotion ? "instant" : "smooth"
      });
    }

    updateButtons() {
      const vertical = this.isVertical();
      const start = vertical
        ? this.panel.scrollTop
        : this.panel.scrollLeft;
      const end = vertical
        ? this.panel.scrollHeight - this.panel.clientHeight
        : this.panel.scrollWidth - this.panel.clientWidth;

      this.upButton.style.setProperty(
        "display",
        start <= 1 ? "none" : "",
        "important"
      );

      this.downButton.style.setProperty(
        "display",
        start >= end - 1 ? "none" : "",
        "important"
      );
    }
  }

  customElements.define("slider-vertical", SliderVertical);
}
